// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getUnassignedEMR } from "../api";
import { UnassignedEMRJobsType } from "../types";

export const useUnassignedEMR = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<UnassignedEMRJobsType>({
    queryKey: ["unassigned-emr", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      return getUnassignedEMR(token, clinicId);
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
